import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GalleryImagesStoreService {
  public galleryImages$: BehaviorSubject<any> = new BehaviorSubject([]);
  public galleryImagesCurrentIdx$: BehaviorSubject<any> = new BehaviorSubject(0);

  constructor() { }

  set setGalleryImages(data) {
    this.galleryImages$.next(data)
  }

  set setCurrentGalleryImages(data) {
    this.galleryImagesCurrentIdx$.next(data)
  }
}
